export const CONFIG_ENDPOINT = '/api/config/'

/** Keys we write to window; must match FRONTEND_CONFIG_KEYS in proxea/proxea/settings/base.py */
const ALLOWED_CONFIG_KEYS = new Set([
  'API_URL',
  'APP_ENVIRONMENT',
  'CUTOFF_TIME_GRACE_PERIOD_MINUTES',
  'DATADOG_APPLICATION_ID',
  'DATADOG_CLIENT_TOKEN',
  'DATADOG_ENVIRONMENT',
  'DATADOG_SERVICE_NAME',
  'DATADOG_VERSION',
  'DATADOG_SITE',
  'DISABLE_TRACKING_FOR_STAFF',
  'FORM_CLAIM_URLS',
  'OFFERS_VISIBILITY_MAX_DAYS',
  'PREVIOUS_RELEASE_TAG',
  'PUSHER_CHANNEL',
  'PUSHER_KEY',
  'PUSHER_ZONE',
  'RELEASE_TOGGLE_AUCTION_SHOW_COMPETITIVE_INFO',
  'RELEASE_TOGGLE_SHOW_MODAL_WHEN_AUTHENTICATED_WITH_DIFFERENT_USER',
  'RELEASE_TOGGLE_STEF_API_DELIVERY_INFORMATION_FEATURE',
  'RELEASE_TOGGLE_KLARYS_V2',
  'SCHEDULER_ORDER_ITEMS_LIMIT',
  'INVOICE_XLSX_SYNC_MAX_DOCUMENTS',
  'AMPLITUDE_API_KEY',
  'AMPLITUDE_HISTORICAL_API_KEY',
  // FIXME: unused by the frontend now; remove once Amplitude is validated in prod.
  'SEGMENT_WRITE_KEY',
  'SOURCE_VERSION',
  'USER_ID_PREFIX',
  'V2_APP_BASE_URL',
  'LEGACY_APP_BASE_URL',
  'WEBSITE_URL',
  'ZENDESK_KEY',
])

const win = window as unknown as Record<string, unknown>

export async function fetchAndPopulateConfig(): Promise<void> {
  try {
    const response = await fetch(CONFIG_ENDPOINT)
    if (!response.ok) {
      // eslint-disable-next-line no-console
      console.warn(`[config] /api/config/ returned ${response.status}`)
      return
    }
    const config: Record<string, unknown> = await response.json()
    for (const [key, value] of Object.entries(config)) {
      if (ALLOWED_CONFIG_KEYS.has(key)) {
        win[key] = value
      }
    }
  } catch {
    // eslint-disable-next-line no-console
    console.warn('[config] /api/config/ fetch failed')
  }
}
